import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconCheckeredFlagSg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-checkered-flag-sg_svg__a)"
      d="M18.594 0C19.336 0 20 .508 20 1.21v11.798c0 .469-.313.898-.86 1.094-1.68.664-3.085.898-4.335.898-2.89 0-4.883-1.21-7.774-1.21-1.406 0-3.086.312-5.156 1.21v4.063c0 .546-.43.937-.938.937C.391 20 0 19.61 0 19.062V.938C0 .43.39 0 .938 0a.95.95 0 0 1 .937.938v.351C4.18.352 5.859.04 7.227.04c2.695 0 4.062 1.25 6.406 1.25 1.094 0 2.422-.273 4.18-1.094.273-.117.507-.195.78-.195ZM4.687 12.148v-2.03c-.664.155-1.367.39-2.109.702l-.703.274v1.875c.938-.39 1.875-.664 2.813-.82Zm0-3.984V6.367c-.664.156-1.367.39-2.109.703l-.703.274v1.758a14.791 14.791 0 0 1 2.813-.938Zm0-3.75v-2.11c-.664.196-1.367.391-2.109.704l-.703.312v2.032a14.791 14.791 0 0 1 2.813-.938Zm4.688 7.695v-2.07c-.703-.195-1.328-.351-2.148-.351-.235 0-.47.039-.704.078v2.148h.508c.86 0 1.602.078 2.344.195Zm0-3.984V6.289c-.703-.195-1.328-.351-2.148-.351-.235 0-.47.039-.665.078v1.836c.196 0 .43-.04.665-.04.82 0 1.484.157 2.148.313Zm0-3.75v-2.11a6.356 6.356 0 0 0-2.148-.35c-.235 0-.47 0-.665.038v2.149c.196 0 .43-.04.665-.04.82 0 1.484.157 2.148.313Zm4.688 8.71v-2.148h-.43c-.938 0-1.68-.156-2.383-.312v1.914c.04 0 .078.04.117.04.899.233 1.758.429 2.695.507Zm0-4.023V7.188h-.43c-.938 0-1.68-.157-2.383-.313v1.797c.703.234 1.484.39 2.383.39h.43Zm0-3.75V3.126c-.157 0-.313.04-.43.04-.938 0-1.68-.157-2.383-.353v2.11c.703.234 1.484.39 2.383.39h.43Zm4.062 7.188V9.922c-.781.312-1.523.547-2.188.742v2.383c.665-.078 1.407-.274 2.188-.547Zm0-4.61V6.173c-.781.312-1.523.547-2.188.742v1.797c.547-.195 1.172-.39 1.876-.742.117-.04.195-.04.312-.078Zm0-3.75V2.11c-.781.312-1.523.585-2.188.742V4.96c.547-.195 1.172-.39 1.876-.742.117-.04.195-.04.312-.078Z"
      opacity={0.6}
    />
    <defs>
      <linearGradient
        id="icon-checkered-flag-sg_svg__a"
        x1={21.5}
        x2={1.694}
        y1={-0.5}
        y2={22.277}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconCheckeredFlagSg;
